/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-input-file__hint[_ngcontent-%COMP%]{margin-top:.41666667em;font-size:75%}@media (min-width:576px){.nsc-input-file__hint[_ngcontent-%COMP%]{margin-top:0}}.nsc-helpText[_ngcontent-%COMP%]{margin-top:-1rem}"];
export { styles as styles };
